export default function BackButton({ handleBack }) {
    return (
        <div className='proposal-form-back-btn-container'>
            <button
                className='proposal-form-btn proposal-form-back-btn'
                onClick={handleBack}
            >Back</button>        
        </div>
    );
}